import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {messageTextValidation, nameValidation, emailValidation, phoneValidation} from '../../../utils/itemValidation';

import * as locations from '../../../constants/dropdown';

import * as commonActionCreators from '../../../actions/common';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, commonActionCreators, usersActionCreators);

import RhinoSelect from '../../common/inputs/RhinoSelect';

class Contact extends React.Component {

  constructor(props) {
    super(props);

    const firstEntry = [{display: 'Location*', 'value': ''}];
    const finalEntry = [{display: 'Other', 'value': 'online@diamondsdirect.com'}];

    let newArray= firstEntry.concat(locations.locations).concat(finalEntry);

    this.state = {
      open: this.props.common.contactOpen,
      closing: false,
      inputName: '',
      inputEmail: '',
      inputPhone: '',
      inputCitystate: '',
      inputMessage: '',
      errorName: null,
      errorEmail: null,
      errorPhone: null,
      errorCitystate: null,
      errorMessage: null,

      locations: newArray,
    };
  }

  getContactClass() {
    if(this.state.closing) {
      return 'Contact closing';
    } else {
      return this.props.common.contactOpen ? 'Contact open' : 'Contact closed';
    }
  }

  closeContact() {
    this.setState({ closing: true });
    setTimeout(() => {
      this.setState({
        open: false,
        closing: false,
      }, () => {
        this.props.commonCloseContact();
      });
    }, 500)
  }

  catchClick(evt) {
    evt.stopPropagation();
  }

  changeName(evt) {
    this.setState({ inputName: evt.target.value }, () => {
      if(this.state.errorName && !nameValidation(this.state.inputName)) {
        this.setState({ errorName: null });
      }
    });
  }

  changeEmail(evt) {
    this.setState({ inputEmail: evt.target.value }, () => {
      if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
        this.setState({ errorEmail: null });
      }
    });
  }

  changePhone(evt) {
    this.setState({ inputPhone: evt.target.value }, () => {
      if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
        this.setState({ errorPhone: null });
      }
    });
  }

  changeCitystate(evt) {
    this.setState({inputCitystate: evt.target.value}, () => {
      if(this.state.errorCitystate && !nameValidation(this.state.inputCitystate)) {
        this.setState({errorCitystate: false});
      }
    });
  }

  changeMessage(evt) {
    this.setState({ inputMessage: evt.target.value }, () => {
      if(this.state.errorMessage && !messageTextValidation(this.state.inputMessage)) {
        this.setState({ errorMessage: null });
      }
    });
  }

  validateAll() {
    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }
    let citystateError = null;
    if(this.state.inputCitystate) {
      citystateError = nameValidation(this.state.inputCitystate);
    }
    let messageError = null;
    if(this.state.inputMessage) {
      messageError = messageTextValidation(this.state.inputMessage);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       citystateError === null &&
       messageError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorCitystate: citystateError,
      errorMessage: messageError
    });

    return !hasErrors;
  }

  submitContactRequest() {
    if(this.validateAll()) {

      let contactData = {
        full_name: this.state.inputName,
        email: this.state.inputEmail,
        phone: this.state.inputPhone,
        location: this.state.inputCitystate,
        message: this.state.inputMessage,
        product_img: this.props.common.contactProduct.image
      }

      this.props.usersContactRequest(contactData);
      this.props.commonContactSent();
      this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue Browsing');
      this.setState({
        inputName: '',
        inputEmail: '',
        inputPhone: '',
        inputCitystate: '',
        inputMessage: '',
        errorName: null,
        errorEmail: null,
        errorPhone: null,
        errorCitystate: null,
        errorMessage: null,
      });
      this.props.commonCloseContact();
    }
  }

  render() {
    return <div className={::this.getContactClass()} onClick={::this.closeContact}>
      <div className='contactBody' onClick={::this.catchClick}>

        <div className='internalWrapper'>

          <div className='closeContact' onClick={::this.closeContact}>
            <div className='closeX'>&times;</div>
          </div>
          <div className='imageWrapper'>
            {this.props.common.contactProduct ?
              <img src={this.props.common.contactProduct.image} /> :
              null
            }
          </div>
          <div className='formWrapper'>
            <div className='formBody'>
              <div className='formTitle'>
                {this.props.common.contactProduct && this.props.common.contactProduct.name ?
                  <span>{this.props.common.contactProduct.name}</span> :
                  <span>One of a Kind Luxury Piece</span>
                }
              </div>
              <div className='formSubTitle'>Complete the form below to schedule an in-person showing.</div>
              <div className='formRow'>
                <input 
                  className={this.state.errorName ? 'textInput error' : 'textInput'}
                  type='text' 
                  placeholder='FULL NAME&#42;'
                  value={this.state.inputName}
                  onChange={::this.changeName} />
                <input 
                  className={this.state.errorEmail ? 'textInput error' : 'textInput'}
                  type='email' 
                  placeholder='EMAIL ADDRESS&#42;'
                  value={this.state.inputEmail}
                  onChange={::this.changeEmail} />
              </div>
              <div className='formRow'>
                <input 
                  className={this.state.errorPhone ? 'textInput error' : 'textInput'}
                  type='text' 
                  placeholder='TELEPHONE'
                  value={this.state.inputPhone}
                  onChange={::this.changePhone} />
                <input 
                  className={this.state.errorCitystate ? 'textInput error' : 'textInput'}
                  type='text' 
                  placeholder='CITY | STATE'
                  value={this.state.inputCitystate}
                  onChange={::this.changeCitystate}
                  style={{display: 'none'}} />
                <RhinoSelect
                  selectClass={'contactSelect contactPageSelect'}
                  required={true}
                  options={this.state.locations}
                  changeMethod={(evt) => this.changeCitystate(evt)}
                  error={this.state.errorCitystate} />
              </div>
              <div className='formRow'>
                <textarea
                  className={this.state.errorMessage ? 'textTextarea error' : 'textTextarea'}
                  placeholder='HOW CAN WE HELP YOU?'
                  value={this.state.inputMessage}
                  onChange={::this.changeMessage}>
                </textarea>
              </div>
              <div className='formRow'>
                <div 
                  className={'contactSubmit actionButton'}
                  onClick={::this.submitContactRequest}>Send</div>
              </div>
            </div>
            <div className='phonePrompt' style={{display: 'none'}}>
              Or call us at: 972-342-6663
            </div>
          </div>

        </div>

      </div>
    </div>
  }
}
export default Contact;

function mapStateToProps(state) {
  return {
    common: state.common
  };
}

export const ContactContainer = connect(
  mapStateToProps,
  allActionCreators
)(Contact);


// WEBPACK FOOTER //
// ./src/components/views/contact/Contact.jsx